module.exports = __webpack_public_path__ + "img/login-bg.1fd2a32f.png";